import { defineMessages } from 'react-intl'

// Tips: 全局配置语言添加app前缀做区分

const demo = defineMessages({
  'app.demo.text': {
    id: 'app.demo.text',
    description: '示例',
    defaultMessage: 'app demo text'
  }
})

const error = defineMessages({
  'app.error.netWork': {
    id: 'app.error.netWork',
    description: '网络错误',
    defaultMessage: 'Network error, please try again later！'
  },
  'app.error.system': {
    id: 'app.error.system',
    description: '系统错误',
    defaultMessage: 'System error, please try it later!'
  },
  'app.error.openUriToastInfo': {
    id: 'app.error.openUriToastInfo',
    defaultMessage: 'Only support Android and iOS system!',
    description: 'open Uri Toast Info'
  },
  'app.error.downloadNotSupport': {
    id: 'app.error.downloadNotSupport',
    defaultMessage: 'Operation System not available yet!',
    description: 'download Not Support'
  },
  'app.error.getCode': {
    id: 'app.error.getCode',
    defaultMessage: 'Please get your code.',
    description: 'get code'
  }
})

export default {
  ...demo,
  ...error
}
